import { __spreadArrays } from "tslib";
import * as React from 'react';
import { Text, DeprecatedSelect, Column } from '@wix/answers-ui-libby';
import { compKey } from './key';
import { CustomFieldType } from '@wix/answers-api';
import { ErrorMsg } from '../contact-form/contact-form-utils';
import { classNames } from '@wix/answers-lib';
import { isFeatureEnabled } from '@wix/answers-experiments';
export var MULTILEVEL_DELIMITER = '|';
var isLastLevel = function (levelValue) { var _a; return !((_a = levelValue.children) === null || _a === void 0 ? void 0 : _a.length) || levelValue.children.every(function (c) { return c.disabled; }); };
var optionRenderer = function (option, optionState) {
    var isSelected = optionState === null || optionState === void 0 ? void 0 : optionState.isSelected;
    return (React.createElement(Text, { color: isSelected ? 't01' : 't30', type: 'hs', className: classNames('multi-level-field-option') }, option.label));
};
var getAllOptions = function (children, mandatory, clearText) {
    var clearOption = {
        value: '',
        label: clearText,
    };
    var optionsWithoutClear = children
        .filter(function (levelValue) { return !levelValue.disabled; })
        .map(function (levelValue) { return ({ value: levelValue.value, label: levelValue.value }); });
    if (mandatory) {
        return optionsWithoutClear;
    }
    var options = __spreadArrays([clearOption], optionsWithoutClear);
    return options;
};
var getSelectedLevels = function (selectedValues, levelValues, currentLevelNumber) {
    if (currentLevelNumber === void 0) { currentLevelNumber = 0; }
    var currentLevelSelectedValue = selectedValues[currentLevelNumber];
    if (!currentLevelSelectedValue) {
        return [];
    }
    var nextLevel = levelValues.find(function (levelValue) { return levelValue.value === currentLevelSelectedValue; });
    if (!nextLevel) {
        return [];
    }
    return __spreadArrays([nextLevel], getSelectedLevels(selectedValues, nextLevel.children || [], currentLevelNumber + 1));
};
var getTranslatedValue = function (value, locale) {
    return value.translatedValues && value.translatedValues[locale] ?
        value.translatedValues[locale].value : value.value;
};
var getTranslatedOptions = function (levelValues, locale) {
    return levelValues.map(function (levelValue) {
        var translatedVal = getTranslatedValue(levelValue, locale);
        return { value: levelValue.value, label: translatedVal };
    });
};
var getTranslatedOption = function (field, selected, locale) {
    var selectedMaybeTranslated = field.multiLevelData ?
        field.multiLevelData.values.filter(function (value) { return value.value === selected; }) : [];
    var returned = selectedMaybeTranslated.length ? getTranslatedValue(selectedMaybeTranslated[0], locale) : selected;
    return { value: returned, label: returned };
};
export var PublicMultilevelField = function (props) {
    var field = props.field, value = props.value, onChange = props.onChange;
    if (field.type !== CustomFieldType.MULTI_LEVEL || !field.multiLevelData) {
        return null;
    }
    var selectedValues = value ? value.split(MULTILEVEL_DELIMITER) : [];
    var selectedLevels = getSelectedLevels(selectedValues, field.multiLevelData.values);
    var renderLevel = function (children, levelNumber) {
        var _a, _b;
        if (levelNumber === void 0) { levelNumber = 0; }
        var selectedValue = selectedValues[levelNumber];
        var selectedValueOption = selectedValue ? {
            value: selectedValue,
            label: selectedValue,
        } : undefined;
        var maybeTranslatedSelectedValueOption = (isFeatureEnabled('MultilevelMultiLingual') && props.locale) ?
            getTranslatedOption(field, selectedValue, props.locale) : selectedValueOption;
        var levelTitle = (_b = (_a = field.multiLevelData) === null || _a === void 0 ? void 0 : _a.fieldLevels[levelNumber]) === null || _b === void 0 ? void 0 : _b.title;
        var onSelectChange = function (selectedOption) {
            if (!selectedOption.value) {
                onChange({ value: selectedValues.slice(0, levelNumber).join(MULTILEVEL_DELIMITER), isComplete: false });
                return;
            }
            var newValue = __spreadArrays(selectedValues.slice(0, levelNumber), [selectedOption.value]).join(MULTILEVEL_DELIMITER);
            var selectedLevelValue = children.find(function (c) { return c.value === selectedOption.value; });
            if (!selectedLevelValue) {
                onChange({ isComplete: false, value: newValue });
                return;
            }
            onChange({ value: newValue, isComplete: isLastLevel(selectedLevelValue) });
        };
        var options = getAllOptions(children, props.mandatory, props.texts.clearText);
        var maybeTranslatedOptions = (isFeatureEnabled('MultilevelMultiLingual') && props.locale) ?
            getTranslatedOptions(children, props.locale) : options;
        if (!maybeTranslatedOptions.filter(function (option) { return option.value; }).length) {
            return null;
        }
        var isEmptyValue = !selectedValue;
        return (React.createElement("div", { className: compKey + "-level-" + levelNumber },
            React.createElement(Column, { gap: '8' },
                React.createElement(Text, { className: compKey + "-level-title", relativeToBody: true, color: 't30' }, levelTitle),
                React.createElement(DeprecatedSelect, { value: maybeTranslatedSelectedValueOption, options: maybeTranslatedOptions, onChange: onSelectChange, placeholder: props.texts.placeholder, className: classNames({ 'empty-level': isEmptyValue }), searchable: false, optionRenderer: optionRenderer, autoFocus: isEmptyValue && !!levelNumber }),
                isEmptyValue && props.validationError && props.mandatory ?
                    React.createElement(ErrorMsg, { isVisible: true, msg: props.validationError }) : null)));
    };
    return (React.createElement("div", { className: compKey + "-wrapper" },
        React.createElement(Column, { className: compKey, gap: '14' },
            renderLevel(field.multiLevelData.values),
            React.createElement(Column, { gap: '14', className: compKey + "-levels" }, selectedLevels.map(function (selectedLevel, idx) { return renderLevel(selectedLevel.children || [], idx + 1); })))));
};
//# sourceMappingURL=index.js.map